import React, { Fragment, useState } from "react";
import {
  Box,
  Flex,
  Spacer,
  Button,
  Icon,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Text,
  Link,
  Grid,
  GridItem,
  Image,
} from "@chakra-ui/react";
import { ReactComponent as LeftArrow } from "../../img/icons/leftArrow.svg";
import { ReactComponent as Star } from "../../img/star.svg";
import { ReactComponent as ChoosenStar } from "../../img/choosenStar.svg";
import { LinkContext } from "../../LinkContext";
import { Parser } from "html-to-react";

interface ErrorAlertProps {
  handleClose: (value: boolean) => void;
}

const ErrorAlert: React.FC<ErrorAlertProps> = ({ handleClose }) => {
  return (
    <Fragment>
      <ModalOverlay onClick={() => handleClose(false)} />
      <ModalContent>
        <ModalHeader>Внимание</ModalHeader>
        <ModalCloseButton />
        <ModalBody mb={4}>
          <Text mb={4}>
            Для добавления направления в перечень избранных Вам необходимо
            авторизоваться через личный кабинет абитуриента
          </Text>

          <iframe
            src="https://priem.mirea.ru/tools/auth/"
            style={{ width: "100%", height: "400px", border: "none" }}
            id="loginIframe"
          />

        </ModalBody>
      </ModalContent>
    </Fragment>
  );
};

interface HeaderProps {
  specId: number;
  directionCode: string;
  directionName: string;
  name: string;
  details: { name: string; html: string | null }[];
  description: string;
  formUnit: {
    id: number;
    name: string;
    abbreviation: string;
    slug: string;
    color_code: string;
    logo_url: string;
  };
  eduLevel: {
    id: number;
    name: string;
    slug: string;
  };
  eduLocation: {
    id: number;
    name: string;
    slug: string;
  };
  favorite: boolean;
  color: string;
  partners: any[];
  setDetailId: (id: number) => void;
}

const Header: React.FC<HeaderProps> = ({
  specId,
  directionCode,
  directionName,
  name,
  details,
  description,
  formUnit,
  eduLevel,
  eduLocation,
  favorite,
  color,
  partners,
  setDetailId,
}) => {
  const [fav, setFav] = useState(favorite);
  const [errorMsg, setErrorMsg] = useState(false);

  const htmlParser = new (Parser as any)();

  const addFav = (appLink: string) => {
    const myHeaders = new Headers();
    myHeaders.append("accept", "application/json");

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow" as RequestRedirect,
    };

    fetch(`${appLink}/lk/api/directions/add_favorite/${specId}`, requestOptions)
      .then((result) => {
        if (result.status === 200) {
          setFav(true);
        } else {
          setErrorMsg(true);
        }
      })
      .catch((error) => console.log("error", error));
  };

  const deleteFav = (appLink: string) => {
    const myHeaders = new Headers();
    myHeaders.append("accept", "application/json");

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow" as RequestRedirect,
    };

    fetch(
      `${appLink}/lk/api/directions/delete_favorite/${specId}`,
      requestOptions
    )
      .then((result) => {
        if (result.status === 200) {
          setFav(false);
        } else {
          setErrorMsg(true);
        }
      })
      .catch((error) => console.log("error", error));
  };

  return (
    <Box
      w="100%"
      px={{
        base: "24px",
        xl: "100px",
      }}
      pb="30px"
      pt="150px"
      bg={color}
    >
      <LinkContext.Consumer>
        {(APP_LINK) => (
          <Box color="white" fontSize="16px">
            <Link href={`${APP_LINK}/guide`}>
              <Icon as={LeftArrow} />
            </Link>
            <Box py="15px" borderBottom="2px dashed white">
              <Text fontSize="41px">{name}</Text>
            </Box>
            <Box
              py="15px"
              display={{
                base: "block",
                md: "flex",
              }}
              borderBottom="2px dashed white"
            >
              <Box>
                <Text fontSize="20px" mb="10px">
                  {`${directionCode} ${directionName}`}
                </Text>
                <Text>
                  {formUnit ? (
                    eduLevel.slug === "bach-spec" ||
                    eduLevel.slug === "magistracy" ? (
                      <Link
                        href={`${APP_LINK}/guide?eduLevel=${eduLevel.slug}&formUnits=${formUnit.id}`}
                      >
                        {formUnit.name}
                      </Link>
                    ) : (
                      <Link
                        href={`${APP_LINK}/guide?eduLevel=${eduLevel.slug}`}
                      >
                        {formUnit.name}
                      </Link>
                    )
                  ) : eduLevel.slug === "bach-spec" ||
                    eduLevel.slug === "magistracy" ? (
                    <Link
                      href={`${APP_LINK}/guide?eduLevel=${eduLevel.slug}&eduLocations=${eduLocation.id}`}
                    >
                      {eduLocation.name}
                    </Link>
                  ) : (
                    <Link href={`${APP_LINK}/guide?eduLevel=${eduLevel.slug}`}>
                      {eduLocation.name}
                    </Link>
                  )}
                </Text>
              </Box>
              <Spacer />
              <Flex
                alignItems="center"
                mt={{
                  base: "10px",
                  md: "0",
                }}
              >
                <Link
                  onClick={
                    !fav
                      ? () => {
                          addFav(APP_LINK);
                        }
                      : () => {
                          deleteFav(APP_LINK);
                        }
                  }
                >
                  <Flex alignItems="center">
                    {fav ? (
                      <Icon as={ChoosenStar} h="20px" w="20px" mr={2} />
                    ) : (
                      <Icon as={Star} h="20px" w="20px" mr={2} />
                    )}
                    <Text mb={0}>{fav ? "В избранном" : "В избранное"}</Text>
                  </Flex>
                </Link>
              </Flex>
            </Box>
            <Grid
              gap="10px"
              templateColumns={{
                base: "1fr",
                md: "repeat(2, 1fr)",
              }}
            >
              <GridItem>
                <Box py="15px">
                  <Text>{htmlParser.parse(description)}</Text>
                </Box>
              </GridItem>
            </Grid>
            {partners?.length > 0 && (
              <Flex py="15px" h="100%">
                <Flex
                  flexDirection="column"
                  w={{
                    base: "100%",
                    lg: "auto",
                  }}
                >
                  <Box p="20px" bg="#F4F4F4" color="#151515">
                    <Text
                      fontSize={{
                        base: "16px",
                        xl: "24px",
                      }}
                      lineHeight={{
                        base: "20px",
                        xl: "29px",
                      }}
                      mb="10px"
                    >
                      {partners[0].pivot.partner_type === "collab"
                        ? "Совместная образовательная программа:"
                        : "Программа реализована при поддержке:"}
                    </Text>
                    <Flex flexDir={"row"} flexWrap={"wrap"}>
                      {partners.map((partner) => (
                        <Image
                          mr={3}
                          mb={3}
                          maxH={{
                            base: "50px",
                            xl: "100px",
                          }}
                          src={partner.logo}
                          alt={partner.name}
                        />
                      ))}
                    </Flex>
                  </Box>
                </Flex>
              </Flex>
            )}
          </Box>
        )}
      </LinkContext.Consumer>
      <Modal isOpen={errorMsg} size={'xl'} onClose={() => setErrorMsg(false)}>
        <ErrorAlert handleClose={setErrorMsg} />
      </Modal>
    </Box>
  );
};

export default Header;
